import React, { useEffect } from "react";
import App from "./App";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate, HashRouter } from 'react-router-dom';
import store from "./Utils/store";
import "ka-table/style.scss";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import "./index.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#092c74",
    },
  },
});

const root = document.getElementById('root');

const AppWrapper = () => {
  // const location = useLocation();


  return (
    <ThemeProvider theme={theme}>
        <Provider store={store}>
          <HashRouter>
            <App />
          </HashRouter>
        </Provider>
    </ThemeProvider>
  );
};

const rootElement = ReactDOM.createRoot(root);
rootElement.render(<AppWrapper />);
